module.exports = __webpack_public_path__ + "img/Wagenburg_ith_Ramp_down.667d9b32.gif";